export const periodEntryApi = {
    heading:[
        {
            head:"Period ID"
        },
        {
            head:"Period Name"
        },
        {
            head:"Description"
        },
        {
            head:"Session"
        },
        {
            head:"Start Date"
        },
        {
            head:"End Date"
        },
        {
            head:"Status"
        },
        {
            head:"Period Year"
        },
        {
            head:"Billing Last Date"
        },
        {
            head:"Discount"
        },
        {
            head:"Alert Status"
        },
        {
            head:"Action"
        }
    ],
    data:[
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
     
       
    ]
}